import { geoCentroid } from "d3-geo";

const MARKERS = [
  { name: "United States of America", coordinates: [-100, 40] },
  { name: "Mexico", coordinates: [-102, 23] },
  { name: "Guatemala", coordinates: [-90.5, 15.5] },
  { name: "Panama", coordinates: [-80, 8.5] },
  { name: "Colombia", coordinates: [-74, 4.5] },
  { name: "Venezuela", coordinates: [-66, 7] },
  { name: "Peru", coordinates: [-75, -10] },
  { name: "Bolivia", coordinates: [-64, -16] },
  { name: "Chile", coordinates: [-71, -30] },
  { name: "Argentina", coordinates: [-64, -34] },
  { name: "Uruguay", coordinates: [-56, -33] },
  { name: "Paraguay", coordinates: [-58, -23] },
  { name: "Brazil", coordinates: [-55, -10] },
  { name: "Australia", coordinates: [134, -25] },
  { name: "Israel", coordinates: [34.85, 31.05] },
];

/** Match `MARKERS[].name` to Natural Earth `properties.NAME` (and known aliases). */
const MARKER_NAMES = MARKERS.map((m) => m.name);
const MARKER_NAMES_SET = new Set(MARKER_NAMES);
MARKER_NAMES_SET.add("United States");

/** Topo NAME / ADMIN → canonical `MARKERS[].name` */
const TOPO_TO_MARKER_NAME = new Map([
  ["United States", "United States of America"],
  ["United States of America", "United States of America"],
]);

function geoLabelsForMapName(mapName) {
  const set = new Set([mapName]);
  for (const [topo, marker] of TOPO_TO_MARKER_NAME) {
    if (marker === mapName) set.add(topo);
  }
  return set;
}

function getIso(geo) {
  const p = geo.properties || {};
  return String(p.ISO_A3 || p.ISO_A3_EH || p.iso_a3 || "").toUpperCase();
}

/** Stable display id from TopoJSON (Natural Earth: prefer `NAME`, then `ADMIN`). */
function countryLabel(geo) {
  const p = geo.properties || {};
  if (typeof p.NAME === "string" && p.NAME.length > 0) return p.NAME;
  if (typeof p.ADMIN === "string" && p.ADMIN.length > 0) return p.ADMIN;
  return "Unknown";
}

function canonicalMarkerNameFromTopo(geo) {
  const label = countryLabel(geo);
  return TOPO_TO_MARKER_NAME.get(label) ?? label;
}

function countryMeta(geo) {
  const p = geo.properties || {};
  return {
    name: countryLabel(geo),
    iso: getIso(geo) || "—",
    region: p.REGION_UN || p.region_un,
    subregion: p.SUBREGION || p.subregion,
    pop: p.POP_EST,
    area: p.AREA_KM2,
  };
}

function isInteractiveGeo(geo) {
  return MARKER_NAMES_SET.has(canonicalMarkerNameFromTopo(geo));
}

function isGeoSelected(geo, selectedCountry) {
  if (!selectedCountry) return false;
  const target = TOPO_TO_MARKER_NAME.get(selectedCountry.name) ?? selectedCountry.name;
  return canonicalMarkerNameFromTopo(geo) === target;
}

function markerMatchesSelection(markerName, selectedCountry) {
  if (!selectedCountry) return false;
  return geoLabelsForMapName(markerName).has(selectedCountry.name);
}

function geoCenterLngLat(geo) {
  try {
    const c = geoCentroid(geo);
    if (Array.isArray(c) && c.length >= 2 && Number.isFinite(c[0]) && Number.isFinite(c[1])) {
      return [c[0], c[1]];
    }
  } catch (_) {
    /* ignore */
  }
  return [0, 12];
}

export {
  MARKERS,
  MARKER_NAMES_SET,
  getIso,
  countryLabel,
  canonicalMarkerNameFromTopo,
  countryMeta,
  isInteractiveGeo,
  isGeoSelected,
  markerMatchesSelection,
  geoCenterLngLat,
};
